import React, {Component, useEffect, useState} from 'react';
import {InputEmail} from 'components/common/InputEmail';
import {InputPassword} from 'components/common/InputPassword';
import {Spinner} from "reactstrap";
import 'assets/sass/sign-up/SignUpForm.scss';
import {app} from "app/app";
import { InputCheckbox } from 'components/common/InputCheckbox';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import {getSetting, KEYS} from "../../settings/settings";

const SignUpForm = (props) => {
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [terms, setTerms] = useState(false);
    const [privacy, setPrivacy] = useState(false);
    const { executeRecaptcha } = useGoogleReCaptcha();

    const handleButton = async () => {
        const reCaptchaToken = getSetting(KEYS.RECAPTCHA_SITE_KEY) && executeRecaptcha ? await executeRecaptcha('createNewAccount') : undefined;
        props.handleSignUp(reCaptchaToken);
    };

    const renderSubmitButton = () => {
        if (props.operationInProcess) {
            return <Spinner className="spinner-color"/>
        } else {
            return <button className={`cta-button ${buttonDisabled && 'disabled'}`} onClick={!buttonDisabled ? handleButton : undefined}>CONFIRMAR</button>
        }
    }

    useEffect(() => {
        handleButtonDisabled();
    }, [terms, privacy]);

    const handleButtonDisabled = () => {

        if(terms && privacy) {
            setButtonDisabled(false);
        } else {
            setButtonDisabled(true);
        }
    }

    const handleTermsCheckbox = (e, state) => {
        setTerms(state);
    }

    const handlePrivacyCheckbox = (e, state) => {
        setPrivacy(state);
    }

    const handleEnter = (event) => {
        if (event.key === 'Enter') {
            props.handleSignUp(event);
        }
    }

    return <div className="sign-up-form" onKeyDown={handleEnter}>
            <InputEmail placeholder="Ingresá tu email" label="Email"
                        errorMessage={props.formData.email.error}
                        onChange={props.handleInputChange}/>
            <InputPassword placeholder="Ingresá tu contraseña" label="Contraseña"
                            errorMessage={props.formData.password.error}
                            onChange={props.handleInputChange}/>
            <div className="sign-up-form-footer">
                {renderSubmitButton()}
            </div>
            <div className="sign-up-terms-and-conditions terms-politicas-register">
                <InputCheckbox
                        handleChange={handleTermsCheckbox}
                        label={<p>Acepto los <a href={app.termsAndConditionsUrl()}>Términos y Condiciones</a></p>}
                />
                &nbsp;
                <InputCheckbox
                    handleChange={handlePrivacyCheckbox}
                    label={<p>Acepto las <a href="https://www.buenbit.com/es-ar/politica-de-privacidad">Políticas de Privacidad</a></p>}
                />
            </div>
        </div>
}

export default SignUpForm;
